import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import GammaServices from '../../services/gammaServices';
import VegaTracker from './VegaTracker';

// Momentum Indicator page: the Vega view (the old Momentum view below is no longer shown).
const MomentIndicatorPage = () => (
  <div style={{ padding: 20 }}>
    <VegaTracker />
  </div>
);

// eslint-disable-next-line no-unused-vars
const VegaDashboard = () => {
  const [selectedOption, setSelectedOption] = useState('Nifty');
  const [greekType, setGreekType] = useState('Vega'); // Vega or Gamma
  const [vegaData, setVegaData] = useState([]);   // ✅ Vega Data
  const [gammaData, setGammaData] = useState([]); // ✅ Gamma Data
  const [data, setData] = useState([]);

  // ✅ Vega Data Fetch
  useEffect(() => {
    const fetchVega = async () => {
      try {
        const res = await GammaServices.getVegaData(selectedOption);
        if (res?.data) {
          setVegaData(res.data); // API से data save
        }
      } catch (error) {
        console.error("Error fetching Vega data", error);
      }
    };
    if (selectedOption) fetchVega();
  }, [selectedOption]);

  // ✅ Gamma Data Fetch
  useEffect(() => {
    const fetchGamma = async () => {
      try {
        const res = await GammaServices.getGammaData(selectedOption);
        if (res?.data) {
          setGammaData(res.data); // API से data save
        }
      } catch (error) {
        console.error("Error fetching Gamma data", error);
      }
    };
    if (selectedOption) fetchGamma();
  }, [selectedOption]);

  // ✅ Chart/Table Data बनाओ Vega या Gamma के हिसाब से
  useEffect(() => {
    const source = greekType === "Vega" ? vegaData : gammaData;

    const updatedData = source.map(item => {
      const call = greekType === 'Vega' ? item.totalVegaCall : item.totalGammaCall;
      const put = greekType === 'Vega' ? item.totalVegaPut : item.totalGammaPut;
      return {
        time: item.time,
        call,
        put,
        difference: Math.abs(put - call),
        trend: put > call ? "Bullish" : "Bearish",
      };
    });

    updatedData.sort((a, b) => (a.time < b.time ? 1 : -1));
    setData(updatedData);
  }, [greekType, vegaData, gammaData]);

  const totalCall = data.reduce((acc, curr) => acc + curr.call, 0).toFixed(2);
  const totalPut = data.reduce((acc, curr) => acc + curr.put, 0).toFixed(2);
  const diff = (totalPut - totalCall).toFixed(2);

  return (
    <div style={{ padding: 20, fontFamily: 'Arial' }}>
      <h4>Expiry : 2025-08-12</h4>

      {/* Dropdowns */}
      <div style={{ display: 'flex', gap: 20 }}>
        <div>
          <label>Select Option Chain: </label>
          <select
            value={selectedOption}
            onChange={e => setSelectedOption(e.target.value)}
            style={{ padding: 5, marginBottom: 20 }}
          >
            <option value="">-- Select --</option>
            <option value="Nifty">NIFTY 50</option>
            <option value="BANKNIFTY">BANKNIFTY</option>
            <option value="FINNIFTY">FINNIFTY</option>
            <option value="MIDCPNIFTY">MIDCPNIFTY</option>
            <option value="SENSEX">SENSEX</option>
          </select>
        </div>

        <div>
          <label>Select Greek: </label>
          <select
            value={greekType}
            onChange={e => setGreekType(e.target.value)}
            style={{ padding: 5, marginBottom: 20 }}
          >
            <option value="Vega">Vega</option>
            <option value="Gamma">Gamma</option>
          </select>
        </div>
      </div>

      {/* Summary */}
      <div style={{ display: 'flex', marginBottom: 20 }}>
        <div style={{ background: 'red', color: 'white', padding: 10, flex: 1 }}>
          Call {greekType}: {totalCall}
        </div>
        <div style={{ background: 'green', color: 'white', padding: 10, flex: 1 }}>
          Put {greekType}: {totalPut}
        </div>
        <div style={{ background: 'black', color: 'white', padding: 10, flex: 1 }}>
          Difference: {diff}
        </div>
      </div>

      {/* Chart */}
      <LineChart width={1000} height={300} data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" />
        <YAxis />
        <Tooltip />
        <Line type="monotone" dataKey="put" stroke="red" />
        <Line type="monotone" dataKey="call" stroke="green" />
      </LineChart>

      {/* Table */}
      <div style={{ height: 300, overflowY: 'auto' }}>
        <table style={{ width: '100%', marginTop: 30, borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#111', color: '#fff', position: "sticky", top: "0" }}>
              <th>Time</th>
              <th>Call {greekType}</th>
              <th>Put {greekType}</th>
              <th>Difference</th>
              <th>Trend</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx}>
                <td>{row.time}</td>
                <td>{row.call.toFixed(2)}</td>
                <td>{row.put.toFixed(2)}</td>
                <td>{row.difference.toFixed(2)}</td>
                <td>
                  <span style={{
                    background: row.trend === "Bullish" ? 'green' : 'red',
                    color: 'white', padding: '3px 8px', borderRadius: 5
                  }}>
                    {row.trend}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MomentIndicatorPage;
